<template>
  <GlobalContainer
    :class="['m-layout tw-relative tw-box-border', {
      'layout-no-header': !hasFirstNavs
    }]"
  >
    <slot name="before-header" />
    <LayoutHeader
      v-if="hasHeader && !isAppWebview"
      :source="source"
      :has-top-bubble="hasTopBubble"
    />
    <FirstNavs v-if="hasFirstNavs" />
    <main class="m-main tw-w-full">
      <slot />
    </main>

    <slot name="footer" />
  </GlobalContainer>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAppStore } from '@ms/stores/app'
import GlobalContainer from '@ms/components/GlobalContainer.vue'
import { subUserPush, unsubUserPush } from 'wap/components/PushPopup'
import chat from '@ms/components/chat/sdk.js'
import LayoutHeader from '../Header'
import FirstNavs from './FirstNavs'

export default {
  name: 'Layout',
  components: {
    GlobalContainer,
    LayoutHeader,
    FirstNavs
  },
  props: {
    // 应用来源
    source: {
      type: String,
      default: ''
    },
    // 是否有一级导航
    hasFirstNavs: {
      type: Boolean,
      default: false
    },
    hasHeader: {
      type: Boolean,
      default: true
    },
    // 是否不订阅 user 推送
    noPush: {
      type: Boolean,
      default: false
    },
    // 是否有 header 浮窗广告
    hasTopBubble: {
      type: Boolean,
      default: false
    },
    hasChat: {
      type: Boolean,
      default: false
    },
    // 页面主题色，默认 dark 深色，支持 light
    theme: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { isAppWebview } = storeToRefs(useAppStore())

    return {
      isAppWebview
    }
  },
  mounted() {
    if (!this.noPush) {
      subUserPush()
    }
    if (this.hasChat) {
      chat.init({ zIndex: 99999 })
    }
  },
  beforeDestroy() {
    !this.noPush && unsubUserPush()
  }
}
</script>

<style lang="less">
.m-layout {
  background: #1b1b1b;

  &.layout-no-header {
    .m-header {
      overflow: hidden;
    }
  }
}
</style>
